import { Link } from "react-router-dom";
import { Star, MapPin, ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "../components/Reveal";
import { REVIEWS } from "../data/content";

const Stars = ({ rating }) => (
  <div className="flex gap-1">
    {[1, 2, 3, 4, 5].map((n) => (
      <Star
        key={n}
        className={`h-4 w-4 ${n <= rating ? "fill-emerald-600 text-emerald-600" : "fill-ink/10 text-ink/10"}`}
      />
    ))}
  </div>
);

export default function ReviewsPage() {
  return (
    <section className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <SectionHeading
          eyebrow="Reviews"
          title="What our customers say."
          sub="Real jobs across Dublin and Kildare — homeowners, builders and landlords."
        />
        <Reveal delay={0.1}>
          <div className="mb-14 flex items-center gap-3 rounded-2xl border border-ink/10 px-5 py-4">
            <Star className="h-6 w-6 fill-emerald-600 text-emerald-600" />
            <div>
              <p className="font-heading text-lg font-black text-ink" data-testid="trustscore">
                4.9 / 5
              </p>
              <p className="text-[11px] text-ink/55">380+ verified reviews</p>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.name} delay={(i % 3) * 0.07} className="h-full">
            <figure className="flex h-full flex-col rounded-2xl border border-ink/10 bg-white p-7 transition-[border-color,box-shadow] duration-300 hover:border-ink/25 hover:shadow-[0_16px_40px_rgba(0,0,0,0.06)]">
              <Stars rating={r.rating} />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-ink/75">
                "{r.text}"
              </blockquote>
              <figcaption className="mt-6 border-t border-ink/10 pt-5">
                <p className="font-heading text-sm font-bold text-ink">{r.name}</p>
                <p className="mt-0.5 flex items-center gap-1 text-xs text-ink/55">
                  <MapPin className="h-3 w-3 text-emerald-700" />
                  {r.location}
                </p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-14 flex flex-col items-start justify-between gap-6 rounded-2xl bg-ink px-8 py-10 sm:flex-row sm:items-center sm:px-12">
          <h2 className="font-heading text-xl font-extrabold text-white sm:text-2xl">
            Join them — your skip could arrive today.
          </h2>
          <Link
            to="/prices"
            data-testid="reviews-book-skip-button"
            className="inline-flex shrink-0 items-center gap-2 rounded-full bg-white px-7 py-3.5 font-heading text-sm font-bold text-ink transition-colors duration-300 hover:bg-emerald-100"
          >
            Book a Skip Now
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </Reveal>
    </section>
  );
}
